import { useState } from 'react';
import Confetti from 'react-confetti';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { Voucher, VoucherAccordionState } from 'models';
import { theme } from 'assets/themes/zizzi';
import Modal from 'components/Modal';
import VoucherInformation from 'components/VoucherInformation';
import PerkzWalletModalSkeleton from './PerksWalletModal.skeleton';

export interface PerkzWalletModalProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading?: boolean;
  voucher?: Voucher;
  showFooter?: boolean;
  onNext?: () => void;
}

export const initialAccordionState: VoucherAccordionState = { code: true, id: false };

const PerkzWalletModal = ({
  isOpen,
  onClose,
  isLoading = false,
  voucher,
  ...voucherInformationProps
}: PerkzWalletModalProps) => {
  const history = useHistory();
  const [runConfetti, setRunConfetti] = useState(true);
  const [accordions, setAccordions] = useState(initialAccordionState);

  const useFullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isSpinToWin = history.location.state?.type === 'spin-to-win' && runConfetti;

  const handleConfettiComplete = () => {
    setTimeout(() => setRunConfetti(false), 3000);
  };

  const confettiSettings = {
    recycle: false,
    run: isSpinToWin,
    width: window.innerWidth,
    colors: [theme.palette.orange],
    onConfettiComplete: handleConfettiComplete,
  };

  const label = voucher?.title || 'Perk Modal';

  const handleOnClose = () => {
    onClose();
    setAccordions(initialAccordionState);
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleOnClose}
      fullScreen={useFullScreen}
      closeType="back"
      aria-label={label}
    >
      {isLoading || !voucher ? (
        <PerkzWalletModalSkeleton />
      ) : (
        <VoucherInformation
          {...voucherInformationProps}
          onClose={handleOnClose}
          accordions={accordions}
          setAccordions={setAccordions}
          voucher={voucher}
        />
      )}
      <Confetti {...confettiSettings} />
    </Modal>
  );
};

export default PerkzWalletModal;
